import React from 'react'
import { Route } from 'react-router-dom'
// import MainTasks from '../Views/Web/Project/SubMenu/SubContract/PlanLayout/MainTask'
import MainTasksPlan from '../Views/Web/Project/SubMenu/SubContract/Plann/main'
// import TaskPlan from '../Views/Web/Project/SubMenu/SubContract/Plann'
import ViewTask from '../Views/Web/Project/SubMenu/Tasks/Components/viewTask'
// import CreateTask from '../Views/Web/Project/SubMenu/Tasks/Components/createTask'
import TaskPlann from '../Views/Web/Project/SubMenu/SubContract/Plann'
import CreateTitlee from '../Views/Web/Project/SubMenu/SubContract/Plann/createTittle'
import MainTaskss from '../Views/Web/Project/SubMenu/SubContract/PlanLayout/MainTask'


function ProjectSubContractroutes() {
  return (
    <Route path="subcontract-activity" element={<MainTaskss />}>
      <Route path='activity/:officeId/:projectId' element={<MainTasksPlan/>}>
     <Route index element={<TaskPlann/>} />
     <Route path="create" element={<CreateTitlee/>} />
     <Route path="view/:taskViewId" element={<ViewTask />} />
    </Route>
      </Route>
  )
}

export default ProjectSubContractroutes 
